<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>Support</h5>
    </div>
    <div class="centros-formbg">
      <div v-if="success.show" class="alert alert-success" role="alert">
        {{ success.message }}
      </div>
      <div class="centros-form">
        <v-form @submit.prevent="submitForm" ref="form" lazy-validation>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.support.email')"
                outlined
                v-model="input.contact"
                :rules="[rules.required]"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.support.topic')"
                outlined
                v-model="input.problem_recap"
                :rules="[rules.required]"
              ></v-text-field>
            </div>
            <div class="col-md-12">
              <label>{{ $t("lang.support.description") }}</label>
              <v-textarea outlined v-model="input.message"></v-textarea>
            </div>
            <div class="col-md-6">
              <label>{{ $t("lang.support.screenshot") }}</label>
              <v-file-input
                :label="$t('lang.common.choose_file')"
                outlined
                v-model="image"
              >
                <template v-slot:append>
                  <div class="mt-1">{{ $t("lang.common.browse") }}</div>
                </template>
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <v-btn
                type="submit"
                rounded
                text
                :loading="loading"
                class="primary white--text text-capitalize"
                >{{ $t("lang.common.done") }}</v-btn
              >
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddUserForm",
  data() {
    return {
      input: {
        contact: null,
      },
      rules: {
        required: (v) => !!v || "Field is required",
      },
      image: null,
      identity: null,
      loading: false,
      success: {
        show: false,
        message: this.$t("lang.support.ticket_created"),
      },
    };
  },
  async mounted() {
    this.identity = await this.$api.user.identity();
    this.input.contact = this.identity.email;
  },
  methods: {
    async submitForm() {
      this.success.show = false;

      if (this.$refs.form.validate()) {
        let input = { ...this.input };
        this.loading = true;
        await this.$api.user.ticket(this.image, input);
        this.success.show = true;
        this.loading = false;
      }
    },
  },
};
</script>
